<script lang="ts">
  import { UserService } from '../services/UserService.svelte';
  import { PageService } from '../services/PageService.svelte';
  import Login from '../modules/users/Login.svelte';
  import MicrosoftCallback from '../modules/users/MicrosoftCallback.svelte';
  import ChangePasswordBox from '../modules/users/components/account/ChangePasswordBox.svelte';
  import AccountTfaAppForcedBox from '../modules/users/components/account/AccountTfaAppForcedBox.svelte';
  import AccountPendingBox from '../modules/users/components/account/AccountPendingBox.svelte';
  import ErrorMessages from '../components/boxes/ErrorMessages.svelte';
  import { CommonTexts } from '../services/CommonTexts';

  // - the requested page stays in the address bar during the login and shows afterwards
  const IsLoggedIn = $derived(UserService.body.isLoggedIn);
  const Page = $derived(PageService.page);
  const MustChangePassword = $derived(UserService.body.todo.includes('password_change'));
  const MustSetupTfaApp = $derived(UserService.body.todo.includes('tfa_app'));
  // - a login without the team USER (a new registration) opens only the pages with `access: 'login'`, the password and the logout
  const IsUser = $derived(UserService.isUser);
  const CanOpenPage = $derived(PageService.canAccess(Page.key));
  const IsConcealed = $derived(IsLoggedIn && IsUser && PageService.isConcealed(Page.key));
  // - the return from Microsoft, logged in or not; it must not be mounted again when the login changes
  const IsMicrosoftCallback = $derived(PageService.path === PageService.getPath('microsoft'));

  // - no refusal: that would tell the module exists
  $effect(() => {
    if (IsConcealed) {
      PageService.goHome();
    }
  });
</script>

<main class="LayoutMain">
  {#if IsMicrosoftCallback}
    <MicrosoftCallback />
  {:else if IsLoggedIn && MustChangePassword}
    <ChangePasswordBox forced={true} />
  {:else if IsLoggedIn && !IsUser && !CanOpenPage}
    <AccountPendingBox />
  {:else if IsLoggedIn && MustSetupTfaApp}
    <AccountTfaAppForcedBox />
  {:else if IsConcealed}
    <!-- on the way to the start page -->
  {:else if IsLoggedIn && !CanOpenPage}
    <!-- never fetched: the code of an admin or root page stays on the server -->
    <ErrorMessages errors={[CommonTexts.format(CommonTexts.NoPageRights, { page: Page.label })]} title={CommonTexts.NoRights} />
  {:else if IsLoggedIn}
    <!-- the page is fetched only when it is opened (its own chunk); while loading the old content is gone, nothing shows -->
    {#key PageService.mountKey}
      {#await PageService.loadPage(Page) then PageComponent}
        <PageComponent />
      {:catch}
        <ErrorMessages errors={[CommonTexts.PageLoadFailed]} title={CommonTexts.LoadFailed} />
      {/await}
    {/key}
  {:else}
    <Login />
  {/if}
</main>

<style lang="scss">
</style>
